// extracted by mini-css-extract-plugin
export default {"list":"SimpleTOC-module--list--4b8c3","item":"SimpleTOC-module--item--31855","active":"SimpleTOC-module--active--c212a"};